import { MoveUpRight } from "lucide-react";
import { SITE } from "../data/site";

const ITEMS = [
    "GET FOUND",
    "GOOGLE BUSINESS",
    "GET BOOKED",
    "WHATSAPP AUTOMATION",
    "GET GROWING",
    "SOCIAL MEDIA CONTENT",
    SITE.whatsappDisplay,
];
// Repeat so each half of the loop is wider than large screens (no gap).
const LOOP = Array.from({ length: 2 }, () => ITEMS).flat();
// Keep the original scroll speed (48s for 6 words) as the loop gets longer.
const DURATION = `${Math.round((48 * LOOP.length) / 6)}s`;

export const Marquee = () => (
    <div className="overflow-hidden border-y border-brand-brown/20 bg-brand-brown-deep py-4" aria-hidden="true">
        <div className="animate-marquee flex w-max" style={{ animationDuration: DURATION }}>
            {[0, 1].map((dup) => (
                <div key={dup} className="flex items-center">
                    {LOOP.map((t, i) => (
                        <span key={`${dup}-${i}`} className="flex items-center">
                            <span className="mx-7 font-mono text-xs font-medium uppercase tracking-[0.35em] text-brand-cream/90 sm:text-sm">
                                {t}
                            </span>
                            <MoveUpRight size={15} className="text-brand-orange" />
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);
